module.exports = __webpack_public_path__ + "static/img/multiShop.33d2cbff.png";